export default "__VITE_ASSET__DfNsP5lg__";